export default __webpack_public_path__ + "static/media/mist.c90a1604.svg";